import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as html2canvas from 'html2canvas'
import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VueI18n from 'vue-i18n'
import jQuery from 'jquery'
import PageHeader from './views/PageHeader'
import i18n from './i18n'

Vue.use(VueI18n)
Vue.use(PageHeader)
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.config.productionTip = true
window.html2canvas = html2canvas
const $ = jQuery
window.$ = $
i18n.locale = 'de'

window.track = (pageName, pageEvent = '', langId = 'de_DE') => {
  let trackName = 'PlaymobilComicCreator: '
  if (pageName) {
    trackName += pageName
  }
  if (pageEvent) {
    trackName += '_' + pageEvent
  }
  if (langId) {
    trackName += '_' + langId
  }

  window.emos3.send({
    content : trackName,
  });
}

new Vue({
  router,
  store,
  i18n,
  methods: {
    doTrack (param) {

    }
  },
  render: h => h(App)
}).$mount('#app')
